import { memo } from 'react';

import styled, { useTheme } from 'styled-components';

import type { AlertType } from './types';

const IconWrapper = styled.div<{
  $alertType: AlertType;
}>(({
  $alertType,

  theme: {
    alert,
  },
}) => ({
  flex: '0 0 auto',
  verticalAlign: 'text-bottom',
  marginRight: '12px',
  display: 'inline-flex',
  alignItems: 'center',
  color: alert.TYPES[$alertType].color,
}));

type IconProps = {
  type: AlertType;
};

export const Icon = memo(({ type }: IconProps) => {
  const { alert } = useTheme();

  return (
    <IconWrapper $alertType={type}>
      {alert.TYPES[type] ? alert.TYPES[type].icon : null}
    </IconWrapper>
  );
});
